import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/design/design/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Note = makeShortcode("Note");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Primer ViewComponents is an implementation of the Primer Design System, using `}<a parentName="p" {...{
        "href": "https://github.com/github/view_component"
      }}>{`ViewComponent`}</a>{`.`}</p>
    <Note variant="warning" mdxType="Note">This library is under active pre-1.0 development. Breaking changes are likely in patch releases.</Note>
    <h2>{`Getting started`}</h2>
    <p>{`In your `}<inlineCode parentName="p">{`Gemfile`}</inlineCode>{`, add:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ruby"
      }}>{`gem "primer_view_components"
`}</code></pre>
    <p>{`In `}<inlineCode parentName="p">{`config/application.rb`}</inlineCode>{`, add `}<strong parentName="p">{`after the application definition`}</strong>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ruby"
      }}>{`require "view_component"
require "primer/view_components/engine"
`}</code></pre>
    <p>{`Optionally, to add the JavaScript behaviours, in your `}<inlineCode parentName="p">{`application.html.erb`}</inlineCode>{` in the `}<inlineCode parentName="p">{`<head>`}</inlineCode>{` tag add:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-erb"
      }}>{`<%= javascript_include_tag("primer_view_components") %>
`}</code></pre>
    <p>{`Or alternatively, you can install the `}<inlineCode parentName="p">{`@primer/view-components`}</inlineCode>{` npm package and in your JavaScript code add:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import '@primer/view-components'
`}</code></pre>
    <p>{`You can also import only the components you need:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import '@primer/view-components/tab_container'
`}</code></pre>
    <h2>{`Usage`}</h2>
    <p>{`Render Primer ViewComponents in Rails templates:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-erb"
      }}>{`<%= render(Primer::Beta::Counter.new(count: 25)) %>
`}</code></pre>
    <h2>{`Dependencies`}</h2>
    <p>{`In addition to the dependencies declared in the `}<inlineCode parentName="p">{`gemspec`}</inlineCode>{`, Primer ViewComponents assumes the presence of `}<a parentName="p" {...{
        "href": "https://primer.style/css/getting-started"
      }}>{`Primer CSS`}</a>{`.`}</p>
    <h2>{`Migration and upgrade guides`}</h2>
    <p>{`Primer ViewComponents are routinely deprecated as they mature. The following guides detail performing component upgrades.`}</p>
    <h3>{`Migrating from Primer CSS`}</h3>
    <p>{`Many Primer CSS use cases are supported by Primer ViewComponents.`}</p>
    <p>{`When migrating from Primer CSS classes to ViewComponents, use this mapping to
help guide your implementation. This list includes components currently in
stable status.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Primer CSS Class`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`ViewComponent`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://primer.style/css/components/labels#states"
            }}><inlineCode parentName="a">{`State`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "/components/state-label/rails"
            }}><inlineCode parentName="a">{`Primer::Beta::State`}</inlineCode></a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://primer.style/css/components/breadcrumb"
            }}><inlineCode parentName="a">{`breadcrumb-item`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "/components/breadcrumbs/rails"
            }}><inlineCode parentName="a">{`Primer::Beta::Breadcrumbs`}</inlineCode></a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://primer.style/css/stickersheet/labels#counters"
            }}><inlineCode parentName="a">{`Counter`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "/components/counter-label/rails"
            }}><inlineCode parentName="a">{`Primer::Beta::Counter`}</inlineCode></a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://primer.style/css/components/subhead"
            }}><inlineCode parentName="a">{`Subhead`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "/components/subhead/rails"
            }}><inlineCode parentName="a">{`Primer::Beta::Subhead`}</inlineCode></a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://primer.style/css/components/blankslate"
            }}><inlineCode parentName="a">{`blankslate`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "/components/blankslate/rails"
            }}><inlineCode parentName="a">{`Primer::Beta::Blankslate`}</inlineCode></a></td>
        </tr>
      </tbody>
    </table>
    <h3>{`Upgrading deprecated components`}</h3>
    <p>{`As Primer ViewComponents are updated, there are often breaking changes and
deprecations that require changes which cannot be auto-corrected with Rubocop or
other tools. These guides will walk you through the upgrade process for specific
components.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Deprecated Component`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Replacement Component`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Guide`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Primer::ButtonComponent`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "/components/button/rails"
            }}><inlineCode parentName="a">{`Primer::Beta::Button`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "/guides/development/rails/migration-guides/primer-button-component"
            }}>{`Upgrade to Primer::Beta::Button`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Primer::LayoutComponent`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "/components/layout/rails"
            }}><inlineCode parentName="a">{`Primer::Alpha::Layout`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "/guides/development/rails/migration-guides/primer-layout-component"
            }}>{`Upgrade to Primer::Alpha::Layout`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Primer::LocalTime`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "/components/relative-time/rails"
            }}><inlineCode parentName="a">{`Primer::Beta::RelativeTime`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "/guides/development/rails/migration-guides/primer-local-time"
            }}>{`Upgrade to Primer::Beta::RelativeTime`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Primer::TimeAgoComponent`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "/components/relative-time/rails"
            }}><inlineCode parentName="a">{`Primer::Beta::RelativeTime`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "/guides/development/rails/migration-guides/primer-time-ago"
            }}>{`Upgrade to Primer::Beta::RelativeTime`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Primer::Truncate`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "/components/truncate/rails"
            }}><inlineCode parentName="a">{`Primer::Beta::Truncate`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "/guides/development/rails/migration-guides/primer-truncate"
            }}>{`Upgrade to Primer::Beta::Truncate`}</a></td>
        </tr>
      </tbody>
    </table>
    <h2>{`More information`}</h2>
    <p>{`See the `}<a parentName="p" {...{
        "href": "https://github.com/primer/view_components"
      }}>{`primer/view_components repository`}</a>{` for more information about how to use and contribute to Primer ViewComponents. For component-specific documentation, check out the Rails section of component guidelines (example: `}<a parentName="p" {...{
        "href": "/components/action-list/rails"
      }}>{`ActionList`}</a>{`).`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      